<template>
	<div>
		<!-- <button @click="change_linear_db" style="position:absolute;left:50%;top:50%">改变数据</button> -->
		<!-- <button id="some" @click="pop">Pop</button>
		<line-chart ref="canvas" :width="400" :height="220" :db="linear_db"></line-chart>
		<bar-chart ref="canvas" :width="500" :height="200" :db="linear_db"></bar-chart>
		<horizontal-bar-chart ref="canvas" :width="500" :height="200" :db="linear_db"></horizontal-bar-chart>
		<pie-chart ref="canvas" :width="500" :height="200" :db="linear_db"></pie-chart>
		<button @click="change_linear_db">改变数据</button>
		<map-point :points.sync="points"></map-point> -->
		<div class="time"><font-awesome-icon icon="clock" class="price_icon" /> {{date}}</div>
		<line-chart ref="canvas" :width="410" :height="250" :db="modal1_db" title="价格走势" class="modal1"></line-chart>
		<MainVarietiesRiseAndFall title="主要品种涨跌情况" :db="modal2_db" class="modal2"></MainVarietiesRiseAndFall>
		<bar-chart ref="canvas" :width="410" :height="250" :db="modal3_db" title="近期统计" class="modal3"></bar-chart>
		<today-statistics :db="modal4_db" title="今日统计" class="modal4"></today-statistics>
		<pie-chart ref="canvas" :width="410" :height="235" :db="modal5_db" title="库存量比例" class="modal5"></pie-chart>
		<most-popular-products :db="modal6_db" title="最受欢迎商品" class="modal6"></most-popular-products>
		<horizontal-bar-chart ref="canvas" :width="410" :height="245" :db="modal7_db" title="交易量排名" class="modal7"></horizontal-bar-chart>
		<div class="infobar">
			<span>{{modal9_db}}</span>
		</div>
		<map-point :points.sync="modal8_db"></map-point>
	</div>
</template>
<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import '@fortawesome/fontawesome-free-solid'

import LineChart from './charts/LineChart'
import BarChart from './charts/BarChart'
import HorizontalBarChart from './charts/HorizontalBarChart'
import PieChart from './charts/PieChart'
import MapPoint from './charts/MapPoint'
import MainVarietiesRiseAndFall from './charts/MainVarietiesRiseAndFall'
import TodayStatistics from './charts/TodayStatistics'
import MostPopularProducts from './charts/MostPopularProducts'

export default {
	components: {
		FontAwesomeIcon,
		LineChart,
		BarChart,
		HorizontalBarChart,
		PieChart,
		MapPoint,
		MainVarietiesRiseAndFall,
		TodayStatistics,
		MostPopularProducts
	},
	data() {
		return {
			date: '1990年5月9日',
			auto_switch: {
				modal1: {
					arr: [],
					index: 0
				},
				modal3: {
					arr: [],
					index: 0
				}
			},
			modal1_db: {
				labels: ['示例1'],
				data: [0],
				title: '加载中...'
			},
			modal2_db: [{
				name: '加载中...',
				icon: '',
				price: '0',
			}],
			modal3_db: {
				labels: ['示例1'],
				data: [0],
				title: '加载中...'
			},
			modal4_db: [{
				label: '加载中...',
				value: ''
			}],
			modal5_db: {
				labels: [],
				data: [1,1,1,1,1],
			},
			modal6_db: ['加载中...'],
			modal7_db: {
				labels: ['加','载','中','','','','','','',''],
				data: [10,9,8,7,6,5,4,3,2,1],
			},
			modal8_db: [{
				position: {
					left: '960px',
					top: '540px'
				},
				name: '',
				pop_text: '加载中...'
			}],
			modal9_db: ''
		}
	},
	watch: {
		modal9_db: function() {
			this.scroollInfobar();
		}
	},
	mounted() {
		//时间动起来
		this.dynamic_time();

		//价格走势动起来
		this.dynamic_modal('modal1',8000);

		//近期统计动起来
		this.dynamic_modal('modal3',8000);

		//获取数据，自动多次调用
		this.get_data('http://exh.cqlw.com/price/data',20000);

		//infobar 滚动
		this.scroollInfobar();
	},
	methods: {
		unbind(obj) {
			return JSON.parse(JSON.stringify(obj));
		},
		get_date(fmt) {
			var date = new Date();
			var o = {   
			    "M+" : date.getMonth()+1,                 //月份   
			    "d+" : date.getDate(),                    //日   
			    "H+" : date.getHours(),                   //小时
			    "m+" : date.getMinutes(),                 //分   
			    "s+" : date.getSeconds(),                 //秒   
			    "q+" : Math.floor((date.getMonth()+3)/3), //季度   
			    "S"  : date.getMilliseconds()             //毫秒   
			};   
			if(/(y+)/.test(fmt))
				fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));   
			for(var k in o)   
				if(new RegExp("("+ k +")").test(fmt))   
					fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));   
				return fmt;
		},
		dynamic_time() {
			//时间动起来
			setInterval(()=>{
				this.date = this.get_date("yyyy年M月d日 HH:mm:ss");
			},1000)
		},
		dynamic_modal(modal,mSecond) {
			//自动切换：自动从auto_switch.modal【NUMBER】.arr里面取出数据填充到modal【NUMBER】_db里面
			//参数：modal：String
			setInterval(()=>{
				if (this.auto_switch[modal]) {} else {
					//modal写错
					return false;
				}
				var arr = this.auto_switch[modal].arr,
					index = this.auto_switch[modal].index;
				if (arr.length > index + 1) {
					//下一个index有数据
					this[modal + '_db'] = this.unbind(arr[index + 1]);
					this.auto_switch[modal].index = index + 1;
				} else if (arr.length > 0) {
					//下一个index无数据，回到index0
					this[modal + '_db'] = this.unbind(arr[0]);
					this.auto_switch[modal].index = 0;
				}
			},mSecond)
		},
		getCoordinate(event) {
			this.$notify.success({
					title: '地图锚点标识',
					message: 'top:'+event.pageY+'px, left:'+event.pageX+'px',
					offset: -10,
				});
		},
		get_data(api,timeout) {
			//数据格式
			// var data = {
			// 	modal1: [
			// 		//价格走势图，根据数组自动切换，以下为2个图示例，可以写任意个
			// 		{
			// 			labels: ['6.2','6.3','昨天','今天'], //可以写任意多个时间横坐标
			// 			data: [200,300,120,150], //每个时间横坐标对应的数据
			// 			title: '板材价格'
			// 		},{
			// 			labels: ['6.1','6.2','6.3','昨天','今天'],
			// 			data: [100,200,300,120,150],
			// 			title: '型材价格'
			// 		}
			// 	],
			// 	modal2: [
			// 		//主要品种涨跌情况，最多可展示6个品种，以下为2个示例：
			// 		{
			// 			name: '品种1', //品种名称
			// 			icon: 'up', //上涨为:up,下跌为:down
			// 			price: '100', //直接写数字，自动加上￥符号
			// 		},{
			// 			name: '品种2', //品种名称
			// 			icon: 'down', //上涨为:up,下跌为:down
			// 			price: '200', //直接写数字，自动加上￥符号
			// 		}
			// 	],
			// 	modal3: [
			// 		//近期统计图，根据数组自动切换，以下为2个图示例，可以写任意个
			// 		{
			// 			labels: ['6.2','6.3','昨天','今天'], //可以写任意多个时间横坐标
			// 			data: [200,300,120,150], //每个时间横坐标对应的数据
			// 			title: '订单数'
			// 		},{
			// 			labels: ['6.1','6.2','6.3','昨天','今天'],
			// 			data: [100,200,300,120,150],
			// 			title: '交易量'
			// 		}
			// 	],
			// 	modal4: [
			// 		//今日统计，最多可显示4个信息，以下为2个示例：
			// 		{
			// 			label: '订单数',
			// 			value: '100'
			// 		},{
			// 			label: '交易量',
			// 			value: '200吨'
			// 		}
			// 	],
			// 	modal5: {
			// 		//存储量比例饼图
			// 		labels: ['板材','型材','建材'], //可以写任意多个标签
			// 		data: [100,150,200], //每个标签对应的数量，自动计算显示比例
			// 	},
			// 	modal6: [
			// 		//最受欢迎商品：仅展示商品名称，最多可展示5个。根据受欢迎程度顺序排列
			// 		'商品1','商品2','商品3','商品4','商品5'
			// 	],
			// 	modal7: {
			// 		//交易量排名
			// 		labels: ['龙文','广茂','其他仓库'], //可以写任意多个仓库，请根据交易量依次排列
			// 		data: [100,80,60] //上述仓库对应的数据
			// 	},
			// 	modal8: [
			// 		//地图：数组，每个点都是数组中的一个对象，以下为2个点示例，可写任意多个点
			// 		{
			// 			position: {
			// 				left: '926px', //仓库位置，请与设计同事确认仓库在屏幕上的位置
			// 				top: '552px' //仓库位置，请与设计同事确认仓库在屏幕上的位置
			// 			},
			// 			name: '龙文仓库', //仓库名称，一个仓库直接写仓库名，多个仓库写仓库数量
			// 			pop_text: '出库10吨' //仓库最新的动态（可留空），自动显示在屏幕上，每次请求仅允许1个动态，可嵌入html代码
			// 		},{
			// 			position: {
			// 				left: '1122px', //仓库位置，请与设计同事确认仓库在屏幕上的位置
			// 				top: '628px' //仓库位置，请与设计同事确认仓库在屏幕上的位置
			// 			},
			// 			name: '3个仓库', //仓库名称，一个仓库直接写仓库名，多个仓库写仓库数量
			// 			pop_text: '广茂仓库<br>出库100吨' //仓库最新的动态（可留空），自动显示在屏幕上，每次请求仅允许1个动态，可嵌入html代码
			// 		}
			// 	],
			// 	modal9: '滚动的一些文字'
			// }
			// window.setTimeout(()=>{
			// 	this.fill_data(data);
			// },2000)
			
			$.ajax({
				url: api,
				type: 'GET',
				dataType: 'json',
				data: {},
			})
			.done((data)=>{
				this.fill_data(data);
			})
			.fail(()=>{
				this.$notify.warning({
					title: '警告',
					message: '服务器连接失败，数据未更新',
					offset: -10
				});
			})
			.always(()=>{
				setTimeout(()=>{
					this.get_data(api,timeout);
				},timeout);
			});
		},
		fill_data(data) {
			data.modal1 != undefined ? this.auto_switch.modal1.arr = data.modal1 : '';
			data.modal2 != undefined ? this.modal2_db = data.modal2 : '';
			data.modal3 != undefined ? this.auto_switch.modal3.arr = data.modal3 : '';
			data.modal4 != undefined ? this.modal4_db = data.modal4 : '';
			data.modal5 != undefined ? this.modal5_db = data.modal5 : '';
			data.modal6 != undefined ? this.modal6_db = data.modal6 : '';
			data.modal7 != undefined ? this.modal7_db = data.modal7 : '';
			data.modal8 != undefined ? this.modal8_db = data.modal8 : '';
			// data.modal9 != undefined ? this.modal9_db = data.modal9 : '';
			this.modal9_db = "百日行动抓安全，防控风险保平安　　　　安全是发展的前提，发展是安全的保障　　　　深入开展安全大排查大整治大执法百日行动";
			data = null;
		},
		scroollInfobar() {
			if (this.modal9_db) {
				//有数据
				$('body').css('background-image', 'url("/static/background-info.png")');
				$('.infobar span').scrollLeft(0);
				$('.infobar span').css('animation', 'none');
				this.$nextTick(()=>{
					var width = $('.infobar span').outerWidth();
					var time = width / 80;
					console.log(width)
					$('.infobar span').css('animation', 'infobarAnimation linear '+time+'s infinite');
				})
			} else {
				//无数据
				$('body').css('background-image', 'url("/static/background.png")');
			}
		}
	}
}

</script>
<style>
html {
	background: #252329;
	color: #fff;
	font-family: "微软雅黑","Microsoft YaHei UI","Microsoft YaHei","PingFang SC","Helvetica Neue",Helvetica,Arial,sans-serif;
}
body {
	margin: 0;
	width: 1919px;
	height: 1079px;
	position: relative;
	background-repeat: no-repeat;
}
.time {
	text-align: center;
	position: absolute;
	left: 0;
	right: 0;
	top: 92px;
	font-size: 19px;
	color: #d5f1ff;
	-webkit-filter: drop-shadow( 0px 3px 2px rgba(0,42,178,.6) );
	filter: drop-shadow( 0px 3px 2px rgba(0,42,178,.6) )
}
.modal1 {
	position: absolute;
	top: 160px;
	left: 36px;
}
.modal2 {
	position: absolute;
	top: 468px;
	left: 31px;
	width: 430px;
	height: 260px;
	overflow:hidden;
}
.modal3 {
	position: absolute;
	top: 800px;
	left: 36px;
}
.modal4 {
	position: absolute;
	top: 982px;
	left: 504px;
	width: 921px;
	height: 69px;
	overflow:hidden;
}
.modal5 {
	position: absolute;
	top: 170px;
	left: 1470px;
}
.modal6 {
	position: absolute;
	top: 467px;
	left: 1460px;
	width: 430px;
	height: 260px;
	overflow:hidden;
}
.modal7 {
	position: absolute;
	top: 800px;
	left: 1465px;
}
.getCoordinate {
	position: absolute;
	left: 460px;
	top: 130px;
	width: 1000px;
	height: 850px;
	z-index: 1;
}
.infobar {
	position: absolute;
	left: 520px;
	top: 173px;
	font-size: 20px;
	font-weight: bold;
	width: 890px;
	border-radius: 8px;
	overflow: hidden;
	white-space: nowrap;
}
.infobar span {
	display: inline-block;
	padding-left: 890px;
}
@keyframes infobarAnimation {
	from {transform: translateX(0);}
	to {transform: translateX(-100%);}
}
</style>



// WEBPACK FOOTER //
// src/components/screen_show.vue